import {useCallback} from 'react';
import useWorkflowStore from '../store';

export const useExportWorkflow = () => {
  const store = useWorkflowStore();
  const {
    nodes,
    edges,
    viewport,
    timelineMarkers,
  } = store;

  return useCallback(() => {
    const data = {
      nodes,
      edges,
      viewport,
      // remove extra data from timelineMarkers to prevent circular reference
      timelineMarkers: timelineMarkers.map(m => ({...m, extra: undefined})),
    };
    const blob = new Blob([JSON.stringify(data, null, 2)], {type: 'application/json'});
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `workflow.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }, [nodes, edges]);
};
